export default function TermsPage() {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-6">Terms & Conditions</h1>
          <p className="text-sm text-muted-foreground mb-8">Last Updated: January 2026</p>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="leading-relaxed">
              By accessing and using InsideHigherEducation, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">2. Use of Service</h2>
            <p className="leading-relaxed">
              You may use our services only for lawful purposes and in accordance with these Terms. You agree not to:
            </p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Use the service in any way that violates applicable laws or regulations</li>
              <li>Impersonate or attempt to impersonate the company or another user</li>
              <li>Engage in any conduct that restricts or inhibits anyone's use of the service</li>
              <li>Use any automated system to access the service</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">3. Intellectual Property</h2>
            <p className="leading-relaxed">
              The service and its original content, features, and functionality are owned by InsideHigherEducation and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">4. User Content</h2>
            <p className="leading-relaxed">
              By submitting content to our website, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and distribute your content in connection with our services.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">5. Disclaimer</h2>
            <p className="leading-relaxed">
              The information provided on InsideHigherEducation is for general informational purposes only. We make no warranties about the completeness, reliability, or accuracy of this information. Any action you take based on the information found on this website is strictly at your own risk.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">6. Limitation of Liability</h2>
            <p className="leading-relaxed">
              InsideHigherEducation shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">7. Changes to Terms</h2>
            <p className="leading-relaxed">
              We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms on this page.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">8. Contact Information</h2>
            <p className="leading-relaxed">
              For questions about these Terms, please contact us at:<br />
              <strong>Email:</strong> <a href="mailto:contact@insidehighereducation.eu" className="text-accent hover:underline">contact@insidehighereducation.eu</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}